<div id="app" class="main">
  <tool-header [langLabel]="langLabel" (langClick)="langClick($event)"></tool-header>

  <router-outlet></router-outlet>

  <!-- <obpp-footer></obpp-footer> -->
</div>
